import { SignupExpertParams } from "@src/api/expert/expertApi";

export type ValidateExpertArgs = {
    form: SignupExpertParams;
};

export const isValidName = (name: string) => /^[A-Za-z가-힣]{2,10}$/.test(name.trim());

export const isValidEmail = (email: string) => /\S+@\S+\.\S+/.test(email.trim());

export const isValidAccount = (account: string) => /^\d{6,20}$/.test(account.replace(/\D/g, ""));

export const validateInputText = (key: keyof SignupExpertParams, value: string) => {
    if (key === "name" && !isValidName(value)) {
        return "한글 또는 영문 2~10자로 입력해주세요.";
    }
    if (key === "email" && !isValidEmail(value)) {
        return "이메일을 올바르게 입력해주세요.";
    }
    if (key === "bankName" && !value.trim()) {
        return "은행명을 입력해주세요. ";
    }
    if (key === "bankAccount" && !isValidAccount(value)) {
        return "숫자 6~20자리로 입력해주세요.";
    }
    return null;
};
